var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribblesLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 129,
    viewBox: "0 0 256 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.5,
    cy: 102,
    rx: 70.5,
    ry: 18,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3987 15.1655C41.4251 14.4972 38.4727 16.3661 37.8043 19.3397C35.4753 29.703 28.7223 34.2155 21.0198 38.8812C20.7468 39.0466 20.4693 39.2139 20.1883 39.3834C16.7232 41.4734 12.7096 43.8942 9.71225 47.0289C6.13347 50.7717 3.89531 55.583 4.32639 62.0037C4.75218 68.3458 8.12378 73.0584 12.5502 76.3362C16.8373 79.5109 22.2577 81.4804 27.5772 82.7369C38.2451 85.2568 50.2211 85.2948 56.862 84.8663C59.9035 84.67 62.2101 82.0453 62.0138 79.0038C61.8176 75.9622 59.1928 73.6557 56.1513 73.8519C50.0871 74.2432 39.3135 74.1682 30.1144 71.9953C25.5004 70.9054 21.7078 69.3836 19.1186 67.4662C16.6687 65.652 15.5005 63.6718 15.3388 61.2644C15.1358 58.2399 16.0314 56.3908 17.6896 54.6566C19.6326 52.6246 22.4424 50.923 26.4074 48.5219C26.5168 48.4557 26.627 48.3889 26.7382 48.3216C34.5934 43.5634 45.1526 36.9789 48.573 21.7599C49.2413 18.7862 47.3724 15.8338 44.3987 15.1655Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.062 75.6777L38.3057 84.4379L42.7088 84.7124L41.062 75.6777Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6148 71.8502L16.3019 78.5199L20.1488 80.2831L22.6148 71.8502Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2102 58.7362L4.86219 54.909L4.43248 59.1188L13.2102 58.7362Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7409 46.4499L23.0734 37.4191L19.3817 39.4877L24.7409 46.4499Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.173 33.2058L35.0253 26.3836L32.9624 30.0785L41.173 33.2058Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0402 81.1741L29.4348 72.0106L33.7778 72.7856L30.0402 81.1741Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1371 69.7421L15.3281 62.9592L17.7768 66.6288L9.1371 69.7421Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5454 46.9915L20.2693 51.9593L17.0615 54.9879L12.5454 46.9915Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3101 35.5857L36.627 41.1356L33.1947 43.9072L29.3101 35.5857Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.141 3.7948L145.598 10.2659L155.098 16.0798L152.683 42.4764L141.598 61.3776L161.224 66.2659C165.23 49.2428 169.493 33.5671 166.703 16.0798C164.97 5.21529 155.808 -0.73209 147.141 3.7948Z",
    fill: "#A8A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.029 24.6798L138.164 29.4189L141.687 39.6452L130.025 53.9639L114.094 62.2665L125.591 74.2086C135.789 64.1275 145.578 55.0949 151.26 41.7323C154.789 33.4304 151.019 25.3093 143.029 24.6798Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4176 66.1051L76.9042 68.8215L87.2224 46.4892L75.0354 40.3154C77.5484 33.0098 83.4935 16.6555 79.2289 9.97962C74.9713 3.31473 71.9374 5.42151 67.6998 7.57324C67.6998 7.57324 69.5394 19.0951 69.5405 19.7015C69.559 29.3092 49.2828 52.7258 50.5027 58.2174C51.7226 63.709 58.4176 66.1051 58.4176 66.1051Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4761 55.1607L55.7269 70.342L79.0895 61.7913L74.8122 48.6545C81.8392 45.2395 97.798 37.8236 99.5357 30.0033C101.271 22.1958 97.5958 21.5265 93.0295 20.0271C93.0295 20.0271 86.0894 29.5695 85.6558 30.0033C78.7868 36.8748 47.5391 39.0665 44.4762 43.8605C41.4133 48.6545 44.4761 55.1607 44.4761 55.1607Z",
    fill: "#ABA9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09 114.266C161.803 114.266 183.93 110.26 187.931 82.517C192.275 79.0995 197.889 76.1248 201.922 74.3436C209.136 72.2599 217.713 67.801 222.036 62.3476C222.597 61.6405 223.016 60.6935 223.29 59.5667C229.493 58.8752 237.32 57.6759 237.626 56.0058C238.014 53.8925 226.876 48.2089 221.509 45.6028C221.216 44.8731 220.894 44.1449 220.54 43.4233C221.757 39.3272 223.492 32.5205 222.015 31.2464C220.809 30.2067 216.273 31.8248 212.54 33.4366C209.651 31.2356 206.179 29.6333 202.099 29.0232C200.856 28.8373 199.47 29.1815 197.894 29.5726C195.439 30.1822 192.524 30.9059 188.977 29.9135L187.564 28.1805C187.564 28.1805 174.015 30.7498 174.617 36.7174C174.87 39.2307 174.32 42.4312 173.779 45.58C173.557 46.8691 174.78 50.334 174.617 51.5551C170.125 51.3364 163.09 50.2246 156.154 51.5551C146.368 53.4322 133.907 55.8224 118.09 55.8224C99.0282 55.8224 73.0981 22.766 52.0981 59.5667C52.0981 96.5635 69.5002 114.266 118.09 114.266Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.9 34.5312C208.9 34.5312 210.731 34.2617 212.02 34.8272C214.232 35.797 217.716 38.7461 217.716 38.7461L219.136 41.4313C219.136 41.4313 216.158 39.2879 214.249 37.9146C212.341 36.5412 208.9 34.5312 208.9 34.5312Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.77 30.0575C199.77 30.0575 205.176 30.5228 207.853 31.8333C211.205 33.4741 215.02 36.3764 217.364 37.961C217.21 35.7638 211.364 32.0317 207.525 30.3696C204.96 29.2587 199.77 30.0575 199.77 30.0575Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.742 30.1614C183.346 30.4528 183.429 30.8244 183.912 30.9191L187.546 31.6324C188.168 31.7545 188.949 31.343 188.859 30.9404L188.207 28.0313C188.117 27.6287 187.235 27.5896 186.725 27.9656L183.742 30.1614Z",
    fill: "#DBA0C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.712 41.6338C195.922 42.0562 197.413 40.3657 197.044 38.8013C196.675 37.237 194.585 36.3913 196.375 35.9689C198.166 35.5465 198.944 36.7016 199.313 38.2659C199.682 39.8303 199.502 41.2114 197.712 41.6338Z",
    fill: "#3D3D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.5 102) rotate(90) scale(18 70.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 45.2218,
    y1: 15.3505,
    x2: 53.6517,
    y2: 80.1537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A1A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 139.598,
    y1: 54.266,
    x2: 149.598,
    y2: 112.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 129,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribblesLoading);
export default __webpack_public_path__ + "static/media/scribbles-loading.99c6649c450c7f02ceea51155707fb69.svg";
export { ForwardRef as ReactComponent };